<script>
import { get } from 'lodash';
import SmallCardAbstract from './small-card-abstract';

export default {
  name: 'instance-details-small-card',
  mixins: [
    SmallCardAbstract,
  ],
  props: {
    icon: {
      required: false,
      default: 'fal fa-industry',
    },
    theme: {
      required: false,
      default: 'instance',
    },
  },
  computed: {
    description() {
      const subdomain = get(this.details, 'data.subdomain', '');
      return `${subdomain}.diet-creator.com`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/card/instance-details-small-card.vue